import moment from "moment";
import { CSVLink } from "react-csv";
import { useState, useEffect, useCallback } from "react";
import download from '../../../../assets/icons/download.svg'

const initProjects = [
    "Porcentaje",
    "Nombre de proyecto",
    "Tamaño de proyecto",
    "Horas estimadas",
    "Horas trabajadas",
    "Diferencia",
    "Seguimiento-gestion",
    "Seguimiento-gestion - Score",
    "Falta de documentación que afectan el alcance",
    "Falta de documentación que afectan el alcance - Score",
    "Negociación",
    "Negociación - Score",
    "Pausa",
    "Pausa - Score",
    "Proveedor",
    "Proveedor - Score",
    "Calidad",
    "Calidad - Score",
    "Cotización",
    "Cotización - Score",
    "Operación - Dificultad técnica",
    "Operación - Dificultad técnica - Score",
    "Operación - Curva de aprendizaje",
    "Operación - Curva de aprendizaje - Score",
    "Web backlog",
    "Web trabajadas",
    "Web porcentaje",
    "Diseño backlog",
    "Diseño trabajadas",
    "Diseño porcentaje",
    "Modelado backlog",
    "Modelado trabajadas",
    "Modelado porcentaje",
    "Unity backlog",
    "Unity trabajadas",
    "Unity porcentaje",
    "Planeación backlog",
    "Planeación trabajadas",
    "Planeación porcentaje",
];

const OverTimeDownloadButton = ({ projects = [], quantity }) => {
    const [downloadProjects, setDownloadProjects] = useState([initProjects]);

    const mapProjects = useCallback((projects) => {
        return projects.map((project) => {
            const { planning, design, web, unity, modeling } = project.timeAreas;
            const {
                name,
                size,
                overtimecomments: comments = [],
                percentage,
                calculatedHours: { total: estimatedHours },
                timeTotalSpent: workingHours,
                difference,
            } = project;
            const commentData = {
                management_monitoring: {
                    score: 0,
                    comment: "",
                },
                missing_documentation: {
                    score: 0,
                    comment: "",
                },
                negotiation: {
                    score: 0,
                    comment: "",
                },
                pause: {
                    score: 0,
                    comment: "",
                },
                provider: {
                    score: 0,
                    comment: "",
                },
                quality: {
                    score: 0,
                    comment: "",
                },
                quotation: {
                    score: 0,
                    comment: "",
                },
                technical_difficulty: {
                    score: 0,
                    comment: "",
                },
                technical_knowledge: {
                    score: 0,
                    comment: "",
                },
            };

            comments.forEach((element) => {
                const { reason, comment, score } = element;
                commentData[reason] = {
                    score,
                    comment,
                };
            });
            /**
             * The order matters. It means, in the order you put your columns, it is the order that you must insert their valiables here.
             */
            return Object.values({
                percentage,
                name,
                size,
                estimatedHours,
                workingHours,
                difference,
                management_monitoring: commentData.management_monitoring.comment,
                management_monitoring_score: commentData.management_monitoring.score,
                missing_documentation: commentData.missing_documentation.comment,
                missing_documentation_score: commentData.missing_documentation.score,
                negotiation: commentData.negotiation.comment,
                negotiation_score: commentData.negotiation.score,
                pause: commentData.pause.comment,
                pause_score: commentData.pause.score,
                provider: commentData.provider.comment,
                provider_score: commentData.provider.score,
                quality: commentData.quality.comment,
                quality_score: commentData.quality.score,
                quotation: commentData.quotation.comment,
                quotation_score: commentData.quotation.score,
                technical_difficulty: commentData.technical_difficulty.comment,
                technical_difficulty_score: commentData.technical_difficulty.score,
                technical_knowledge: commentData.technical_knowledge.comment,
                technical_knowledge_score: commentData.technical_knowledge.score,
                estimatedWeb: web.timeEstimated,
                workingWeb: web.timeTotalSpentArea,
                percentageWeb: web.percentage,
                estimatedDesign: design.timeEstimated,
                workingDesing: design.timeTotalSpentArea,
                percentageDesing: design.percentage,
                estimatedModeling: modeling.timeEstimated,
                workingModeling: modeling.timeTotalSpentArea,
                percentageModeling: modeling.percentage,
                estimatedUnity: unity.timeEstimated,
                workingUnity: unity.timeTotalSpentArea,
                percentageUnity: unity.percentage,
                estimatedPlanning: planning.timeEstimated,
                workingPlanning: planning.timeTotalSpentArea,
                percentagePlanning: planning.percentage,
            });
        });
    }, []);

    const setTotalMapping = useCallback(
        (mapedProjects) => {
            const totalsRow = {};
            const totalData = [];

            Object.entries(quantity).forEach(([_, value]) => {
                if (value !== 0 && !value) return null;
                totalsRow[value.title] = value.times;
            });

            const {
                management_monitoring,
                missing_documentation,
                negotiation,
                pause,
                provider,
                quality,
                quotation,
                technical_difficulty,
                technical_knowledge,
            } = totalsRow;
            const totals = [
                management_monitoring,
                missing_documentation,
                negotiation,
                pause,
                provider,
                quality,
                quotation,
                technical_difficulty,
                technical_knowledge,
            ];
            totals.forEach((total) => {
                totalData.push("");
                totalData.push(total);
            });
            return [initProjects].concat(mapedProjects).concat([["Total", "", "", "", "", "", ...totalData]]);
        },
        [quantity]
    );

    useEffect(() => {
        setDownloadProjects(() => {
            const mapedProjects = mapProjects(projects);

            if (quantity) return setTotalMapping(mapedProjects);
            return [initProjects].concat(mapedProjects);
        });
    }, [mapProjects, projects, quantity, setTotalMapping]);

    return (
        <CSVLink
            filename={`proyectos-rojo-${moment(new Date()).format("DD/MM/yyyy")}`}
            data={downloadProjects}
            className="active:scale-105 duration-300"
        >
            <div className="w-full h-full flex gap-1 justify-center items-center px-2 py-2  rounded-md bg-[#1677FF] lg:w-full lg:max-w-[328px] lg:justify-self-end  text-white active:scale-105 duration-300">
                <img src={download} alt="dowload" className="w-4 h-full m-auto" />
                <p className="text-[11px] font-bold leading-normal">Descargar los comentarios de todos los proyectos</p>
            </div>
        </CSVLink>
    );
};

export default OverTimeDownloadButton;
